import { GET_REPORTE } from "../actions/types";

const INITIAL_STATE = { rows: [], totales: {}, norma: {} };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_REPORTE:
      // Validamos shape: el backend devuelve
      // { status, data: { rows, totales, norma }, message }
      if (action.payload && action.payload.data) {
        return {
          rows: action.payload.data.rows || [],
          totales: action.payload.data.totales || {},
          norma: action.payload.data.norma || {},
        };
      }
      return state;

    default:
      return state;
  }
};
